
if (document.body.classList.contains('home')) {
	const homeTextObserver = new IntersectionObserver(animateHomeText, {
		threshold: 0,
		rootMargin: "-30%"
	})

	jQuery('.animate-col-1, .animate-col-2, .animate-col-3').each( ( _, el ) => {
		homeTextObserver.observe(el);
	})

	function animateHomeText(entries) {
		entries.forEach( entry => {
			if (entry.isIntersecting) {
				const $el = jQuery(entry.target);
				if ( $el.hasClass('animate-col-1') ) {
					setTimeout(function(){
						$el.find('.startTyping1').css('display','inline-block');
					}, 300);
					setTimeout(function(){
						$el.find('.startTyping2').css('display','inline-block');
					}, 600);
					setTimeout(function(){
						$el.find('.startTyping3').css('display','inline-block');
					}, 900);
					setTimeout(function(){
						$el.find('.h3').addClass('stopTyping');
					}, 3500);
				} else if ($el.hasClass('animate-col-2')) {
					setTimeout(function(){
						$el.find('.wave span').addClass('waved');
					}, 600);
				} else if ($el.hasClass('animate-col-3')) {
					setTimeout(function(){
						$el.find('.grow').addClass('grown');
					}, 1200);
				}
				homeTextObserver.unobserve($el.get(0));
			}
		})
	}
}

if (document.querySelectorAll('scroll-col')) {
	function scrollerOpacityOn(e) {
		jQuery(e.currentTarget).siblings('.scroll-col').css('opacity','.3');
	}
	function scrollerOpacityOff(e) {
		jQuery(e.currentTarget).siblings('.scroll-col').css('opacity','1');
	}
	const isTabletAndUp = window.matchMedia('(min-width: 1024px)');
	let listenersSet = false;
	function setUpListeners() {
		if ( isTabletAndUp.matches && !listenersSet ) {
			jQuery('.scroll-col').on( 'mouseenter', scrollerOpacityOn);
			jQuery('.scroll-col').on('mouseleave',  scrollerOpacityOff);
			listenersSet = true;
		} else if (listenersSet) {
			jQuery('.scroll-col').off( 'mouseenter', scrollerOpacityOn);
			jQuery('.scroll-col').off('mouseleave',  scrollerOpacityOff);
			listenersSet = false;
		}
	}
	setUpListeners();
	isTabletAndUp.addEventListener( 'change', setUpListeners);
}